import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 获取消息详情（自动标记为已读）
 * @param {number} id - 消息ID
 * @returns {Promise}
 */
export const get_message_detail = (id) => {
  // 后端使用POST方法，参数从Body JSON传递
  return api.post(`${ApiEndpointConstants.MESSAGE_DETAIL}`, { id });
};
